import { render } from "./forbidden.vue?vue&type=template&id=72d66ec3"
const script = {}

import exportComponent from "D:\\Projects\\GCTUSMS\\codev1\\apply_online\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__